import { render, staticRenderFns } from "./QualityAssuranceQuestionnaireCreateEditPage.vue?vue&type=template&id=232ba852&"
import script from "./QualityAssuranceQuestionnaireCreateEditPage.vue?vue&type=script&lang=js&"
export * from "./QualityAssuranceQuestionnaireCreateEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports